<template>
  <div>
    <div class="service-info" v-show="!isInit.isInit">
      <div
        class="service-items fixed-top"
        :class="{ 'is-visible': isTopVisible }"
      >
        <div
          class="service-item"
          v-for="(item, index) in serviceItems"
          :key="index"
          v-show="
            (item.name == '附件信息' && permissions['Estate.LookMaterials']) ||
            item.name != '附件信息'
          "
          @click="serviceItemChange(item)"
        >
          <span :class="{ 'isactive': item.isActive }">{{ item.name }}</span>
          <i class="el-icon-success success-icon" v-if="item.status"></i>
          <i class="el-icon-success" v-else></i>
        </div>
      </div>
      <div class="service-items" ref="serviceItems">
        <div
          class="service-item"
          v-for="(item, index) in serviceItems"
          :key="index"
          v-show="
            (item.name == '附件信息' && permissions['Estate.LookMaterials']) ||
            item.name != '附件信息'
          "
          @click="serviceItemChange(item)"
        >
          <span :class="{ 'isactive': item.isActive }">{{ item.name }}</span>
          <i class="el-icon-success success-icon" v-if="item.status"></i>
          <i class="el-icon-success" v-else></i>
        </div>
      </div>
      <div class="detail-main">
        <div class="detail-item estate-basic" ref="estateBasic">
          <div class="detail-title">
            基本信息
            <span class="edit-btn" @click="editModule('basic')">编辑</span>
          </div>
          <div class="detail-item-main">
            <el-form label-width="6rem" label-position="left">
              <div class="basic-items">
                <div class="basic-item">
                  <el-form-item label="项目地址">
                    {{ estateBasic.city }}{{ estateBasic.district
                    }}{{ estateBasic.street }}{{ estateBasic.business
                    }}{{ estateBasic.realAddress }}
                  </el-form-item>
                  <el-form-item label="推广名称">
                    {{ estateBasic.promotionName | nullValue }}
                  </el-form-item>
                  <el-form-item label="概要地址">
                    {{ estateBasic.synopsisAddress | nullValue }}
                  </el-form-item>
                  <el-form-item label="地理标注">
                    {{ estateBasic.longitude }},{{ estateBasic.latitude }}
                  </el-form-item>
                  <el-form-item label="用途">
                    <div
                      v-if="
                        estateBasic.usingTypes && estateBasic.usingTypes.length
                      "
                    >
                      <span
                        v-for="(item, index) in estateBasic.usingTypes"
                        :key="index"
                        >{{ item }}
                      </span>
                    </div>
                    <div v-else>—</div>
                  </el-form-item>
                  <el-form-item label="销售进度">
                    {{ estateBasic.saleStatus | nullValue }}
                  </el-form-item>
                  <el-form-item label="可住情况">
                    {{ estateBasic.reside | nullValue }}
                  </el-form-item>
                  <el-form-item label="总价区间">
                    {{ estateBasic.minTotalPrice }} -
                    {{ estateBasic.maxTotalPrice }} 万元
                  </el-form-item>
                  <el-form-item label="售楼地址">
                    {{ estateBasic.saleAddress | nullValue }}
                  </el-form-item>
                  <el-form-item label="开盘时间">
                    {{ estateBasic.launchTime | dateFormatYMD }}
                  </el-form-item>
                  <el-form-item label="代理时间">
                    <span v-if="estateBasic.sellingStartTime"
                      >{{ estateBasic.sellingStartTime | dateFormatYMD }} ~
                      {{ estateBasic.sellingEndTime | dateFormatYMD }}</span
                    >
                    <span v-else>—</span>
                  </el-form-item>
                  <el-form-item label="物业公司">
                    {{ estateBasic.serviceCompany | nullValue }}
                  </el-form-item>
                </div>
                <div class="basic-item">
                  <el-form-item label="楼盘名称">
                    {{ estateBasic.name | nullValue }}
                  </el-form-item>
                  <el-form-item label="注册名称">
                    {{ estateBasic.registerName | nullValue }}
                  </el-form-item>
                  <el-form-item label="建筑类型">
                    {{ estateBasic.buildType | nullValue }}
                  </el-form-item>
                  <el-form-item label="均价区间">
                    {{ estateBasic.minPrice }} -
                    {{ estateBasic.maxPrice }} 元/㎡
                  </el-form-item>
                  <el-form-item label="开发商">
                    {{ estateBasic.developerName | nullValue }}
                  </el-form-item>
                  <el-form-item label="售楼处电话">
                    {{ estateBasic.salePhoneNumber | nullValue }}
                  </el-form-item>
                  <el-form-item label="交房时间">
                    {{ estateBasic.deliveryTime | dateFormatYMD }}
                  </el-form-item>
                  <el-form-item label="竣工时间">
                    {{ estateBasic.buildTime | dateFormatYMD }}
                  </el-form-item>
                  <el-form-item label="物业电话">
                    {{ estateBasic.servicePhoneNumber | nullValue }}
                  </el-form-item>
                  <el-form-item label="物业管理费">
                    {{
                      estateBasic.serviceFee
                        ? estateBasic.serviceFee + "元/㎡/月"
                        : "—"
                    }}
                  </el-form-item>
                  <el-form-item label="物业地址" class="margin-bottom">
                    {{ estateBasic.serviceAddress | nullValue }}
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="detail-item project-counselors" ref="projectCounselors">
          <div class="detail-title">
            项目人员
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="editModule('counselors')"
              v-if="!counselors.length"
              >添加</el-button
            >
          </div>
          <div class="detail-item-main">
            <el-table :data="counselors" border>
              <el-table-column label="项目负责人">
                <template slot-scope="scope">
                  <div v-if="scope.row.managers.length">
                    <div
                      v-for="(item, index) in scope.row.managers"
                      :key="index"
                    >
                      {{ item.userName }} {{ item.userPhoneNumber }}
                    </div>
                  </div>
                  <div v-else>—</div>
                </template>
              </el-table-column>
              <el-table-column label="项目助理">
                <template slot-scope="scope">
                  <div v-if="scope.row.assistants.length">
                    <div
                      v-for="(item, index) in scope.row.assistants"
                      :key="index"
                    >
                      {{ item.userName }} {{ item.userPhoneNumber }}
                    </div>
                  </div>
                  <div v-else>—</div>
                </template>
              </el-table-column>
              <el-table-column label="案场接待">
                <template slot-scope="scope">
                  <div v-if="scope.row.receivers.length">
                    <div
                      v-for="(item, index) in scope.row.receivers"
                      :key="index"
                    >
                      {{ item.userName }} {{ item.userPhoneNumber }}
                    </div>
                  </div>
                  <div v-else>—</div>
                </template>
              </el-table-column>
              <el-table-column prop="developers" label="开发商/代理商对接人">
                <template slot-scope="scope">
                  <div v-if="scope.row.developers.length">
                    <div
                      v-for="(item, index) in scope.row.developers"
                      :key="index"
                    >
                      {{ item.userName }} {{ item.userPhoneNumber }}
                    </div>
                  </div>
                  <div v-else>—</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation">
                    <el-button
                      @click.native.prevent="editCounselors(scope.row)"
                      type="text"
                      >编辑</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="detail-item sale-point" ref="salePoint">
          <div class="detail-title">
            楼盘卖点
            <span class="edit-btn" @click="editModule('salePoint')">编辑</span>
          </div>
          <div class="detail-item-main">
            <el-form label-width="6rem" label-position="left">
              <el-form-item label="项目特色">
                <div v-if="salePoint.features.length">
                  <span
                    class="estate-potint"
                    v-for="(item, index) in salePoint.features"
                    :key="index"
                    >{{ item }}</span
                  >
                </div>
                <span v-else>—</span>
              </el-form-item>
              <el-form-item label="项目表述">
                <div class="description">
                  {{ salePoint.description | nullValue }}
                </div>
              </el-form-item>
              <el-form-item label="周边配套" class="auto-height margin-bottom">
                {{ salePoint.perimeter | nullValue }}
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="detail-item estate-basic" ref="community">
          <div class="detail-title">
            小区信息
            <span class="edit-btn" @click="editModule('community')">编辑</span>
          </div>
          <div class="detail-item-main">
            <el-form label-width="6rem" label-position="left">
              <div class="basic-items">
                <div class="basic-item">
                  <el-form-item label="产权性质">
                    <div v-if="community.useRightTypes">
                      <span
                        v-for="(item, index) in community.useRightTypes"
                        :key="index"
                        class="item-value"
                        >{{ item }}</span
                      >
                    </div>
                    <div v-else>—</div>
                  </el-form-item>
                  <el-form-item label="建筑面积">
                    {{ community.landSquare?community.landSquare+' ㎡':'—' }}
                  </el-form-item>
                  <el-form-item label="容积率">
                    {{ community.plotRate ? community.plotRate + "%" : "—" }}
                  </el-form-item>
                  <el-form-item label="规划户数">
                    {{ community.householdCount | nullValue }}
                  </el-form-item>
                  <el-form-item label="地下车位数">
                    {{ community.undergroundCarportCount | nullValue }}
                  </el-form-item>
                  <el-form-item label="车位总数">
                    {{
                      (community.undergroundCarportCount +
                        community.overgroundCarportCount)
                        | nullValue
                    }}
                  </el-form-item>
                  <el-form-item label="有无电梯">
                    {{ community.isElevator ? "有" : "无" }}
                  </el-form-item>
                  <el-form-item label="供水类型">
                    {{ community.waterType | nullValue }}
                  </el-form-item>
                  <el-form-item label="供暖类型">
                    {{ community.heatType | nullValue }}
                  </el-form-item>
                </div>
                <div class="basic-item">
                  <el-form-item label="产权年限">
                    <div v-if="community.useRightYears">
                      <span
                        v-for="(item, index) in community.useRightYears"
                        :key="index"
                        class="item-value"
                        >{{ item }}</span
                      >
                    </div>
                    <div v-else>—</div>
                  </el-form-item>
                  <el-form-item label="占地面积">
                    {{ community.square?community.square+' ㎡':'—' }}
                  </el-form-item>
                  <el-form-item label="绿化率">
                    {{ community.greenRate ? community.greenRate + "%" : "—" }}
                  </el-form-item>
                  <el-form-item label="装修情况">
                    {{ community.decoration | nullValue }}
                  </el-form-item>
                  <el-form-item label="地上车位数">
                    {{ community.overgroundCarportCount | nullValue }}
                  </el-form-item>
                  <el-form-item label="楼栋总数">
                    {{ community.buildingCount | nullValue }}
                  </el-form-item>
                  <el-form-item label="建筑层数">
                    {{ community.floorTotalCount | nullValue }}
                  </el-form-item>
                  <el-form-item label="有无燃气">
                    {{ community.isGas ? "有" : "无" }}
                  </el-form-item>
                  <el-form-item label="供电类型">
                    {{ community.electricityType | nullValue }}
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="detail-item estate-map" ref="estateMap">
          <div class="detail-title">周边信息</div>
          <div class="detail-item-main" v-if="center.lng">
            <baidu-map
              :center="center"
              :zoom="zoom"
              @ready="handlerMap"
              id="estateMap"
            >
              <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
              <bm-marker
                :position="center"
                :dragging="true"
                animation="BMAP_ANIMATION_BOUNCE"
              ></bm-marker>
              <div class="map-box">
                <el-tabs
                  type="border-card"
                  class="map-detail"
                  @tab-click="switchMapTab"
                >
                  <el-tab-pane label="交通">
                    <el-tabs
                      class="detail-tab traffic-tab"
                      @tab-click="switchMapTab"
                    >
                      <el-tab-pane label="公交站"></el-tab-pane>
                      <el-tab-pane label="地铁站"></el-tab-pane>
                    </el-tabs>
                  </el-tab-pane>
                  <el-tab-pane label="教育">
                    <el-tabs
                      class="detail-tab education-tab"
                      @tab-click="switchMapTab"
                      v-model="activeEducation"
                    >
                      <el-tab-pane label="幼儿园" name="幼儿园"></el-tab-pane>
                      <el-tab-pane label="小学" name="小学"></el-tab-pane>
                      <el-tab-pane label="中学" name="中学"></el-tab-pane>
                      <el-tab-pane label="大学" name="大学"></el-tab-pane>
                    </el-tabs>
                  </el-tab-pane>
                  <el-tab-pane label="医疗">
                    <el-tabs
                      class="detail-tab medical-tab"
                      @tab-click="switchMapTab"
                      v-model="activeMedical"
                    >
                      <el-tab-pane label="医院" name="医院"></el-tab-pane>
                      <el-tab-pane label="药店" name="药店"></el-tab-pane>
                    </el-tabs>
                  </el-tab-pane>
                  <el-tab-pane label="购物">
                    <el-tabs
                      class="detail-tab shop-tab"
                      @tab-click="switchMapTab"
                      v-model="activeShop"
                    >
                      <el-tab-pane label="商场" name="商场"></el-tab-pane>
                      <el-tab-pane label="超市" name="超市"></el-tab-pane>
                      <el-tab-pane label="市场" name="市场"></el-tab-pane>
                    </el-tabs>
                  </el-tab-pane>
                  <el-tab-pane label="生活">
                    <el-tabs
                      class="detail-tab live-tab"
                      @tab-click="switchMapTab"
                      v-model="activeLive"
                    >
                      <el-tab-pane label="银行" name="银行"></el-tab-pane>
                      <el-tab-pane label="ATM" name="ATM"></el-tab-pane>
                      <el-tab-pane label="餐厅" name="餐厅"></el-tab-pane>
                      <el-tab-pane label="咖啡馆" name="咖啡馆"></el-tab-pane>
                    </el-tabs>
                  </el-tab-pane>
                  <el-tab-pane label="娱乐">
                    <el-tabs
                      class="detail-tab recreation-tab"
                      @tab-click="switchMapTab"
                      v-model="activeRecreation"
                    >
                      <el-tab-pane label="公园" name="公园"></el-tab-pane>
                      <el-tab-pane label="电影院" name="电影院"></el-tab-pane>
                      <el-tab-pane label="健身房" name="健身房"></el-tab-pane>
                      <el-tab-pane label="体育馆" name="体育馆"></el-tab-pane>
                    </el-tabs>
                  </el-tab-pane>
                </el-tabs>
                <div class="box-main">
                  <bm-local-search
                    :nearby="nearby"
                    :keyword="keyword"
                    :panel="true"
                  ></bm-local-search>
                </div>
              </div>
            </baidu-map>
          </div>
        </div>
        <div class="detail-item estate-type" ref="estateType">
          <div class="detail-title">
            主力户型
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="editModule('estateType')"
              >添加</el-button
            >
          </div>
          <div class="detail-item-main" v-if="estateTypes.length">
            <div class="type-item" v-for="item in estateTypes" :key="item.id">
              <div class="type-left">
                <el-image :src="item.coverUrl" lazy></el-image>
                <div class="type-detail-items">
                  <div class="type-name">
                    <span>{{ item.name }}</span>
                    <span class="type-rooms"
                      >{{ item.bedroomNumber }}室{{ item.livingRoomNumber }}厅{{
                        item.balconyNumber
                      }}阳台{{ item.kitchenNumber }}厨{{
                        item.bathroomNumber
                      }}卫</span
                    >
                    <span v-if="item.orientationType"
                      >（朝{{ item.orientationType }}）</span
                    >
                  </div>
                  <div class="type-detail">
                    <span class="type-detail-item">
                      <span class="detail-lable">建筑面积：</span>
                      {{ item.buildArea?item.buildArea+' ㎡':'—' }}
                    </span>
                    <span class="type-detail-item">
                      <span class="detail-lable">室内面积：</span>
                      {{ item.indoorArea?item.indoorArea+' ㎡':'—' }}
                    </span>
                    <span>
                      <span class="detail-lable">装修：</span>
                      {{ item.decoration | nullValue }}
                    </span>
                  </div>
                  <div class="type-detail" v-if="item.isMainPush">
                    <span class="type-detail-item">
                      <span class="detail-lable">主推优先级：</span>
                      {{ item.sort }}
                    </span>
                    <span>
                      <span class="detail-lable">主推起止时间：</span>
                      {{ item.pushStartTime | dateFormatYMD }}~{{
                        item.pushEndTime | dateFormatYMD
                      }}
                    </span>
                  </div>
                  <div class="type-detail">
                    <span class="detail-lable">备注：</span>
                    {{ item.more | nullValue }}
                  </div>
                </div>
              </div>
              <div class="type-right">
                <div>
                  <span class="detail-lable">总价：</span>
                  {{ item.totalPrice?item.totalPrice+'万元':'—' }}
                </div>
                <div class="type-btns">
                  <span class="edit-type" @click="editEstateType(item)"
                    >编辑</span
                  >
                  <span class="del-type" @click="delEstateType(item.id)"
                    >删除</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-item estate-photos photo-album" ref="estatePhotos">
          <div class="detail-title">相册信息</div>
          <div class="detail-item-main">
            <el-tabs
              v-model="activePhotos"
              @tab-click="switchPhotos"
              class="estate-detail-tab photo-tab"
            >
              <el-tab-pane
                v-for="(item, index) in photos"
                :key="index"
                :label="item.type + '（' + item.number + '）'"
                :name="item.type"
              ></el-tab-pane>
            </el-tabs>
            <div class="photos-operation">
              <el-checkbox
                v-model="photosAllChecked"
                class="all-check"
                @change="checkAllPhotos"
                >全选</el-checkbox
              >

              <el-select
                v-model="photoSelectText"
                class="photos-select"
                @change="photosSelect"
                :disabled="!isPhotosOperationDisabled()"
              >
                <el-option
                  v-for="item in photosType"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                :disabled="!isPhotosOperationDisabled()"
                @click="delBatchPhotos"
                >删除</el-button
              >
              <el-button type="primary" @click="isUploadPhotos = true"
                >添加照片</el-button
              >
            </div>
            <div class="photos-main">
              <div
                class="photo-item"
                v-for="(item, index) in photo"
                :key="index"
                v-show="photo.length"
              >
                <el-image
                  :src="item.url"
                  :preview-src-list="getSrcList(index)"
                  class="photo-img"
                  lazy
                ></el-image>
                <div class="cover" v-if="item.isCover">封面</div>
                <el-checkbox
                  v-model="item.checked"
                  class="item-checked"
                  @change="checkItem(item.checked, 'photo')"
                ></el-checkbox>
                <div class="photo-detail">
                  <span>{{ item.type }}</span>
                  <div class="name-utc">
                    {{ item.creationTime | dateFormat }}
                  </div>
                  <div class="detail-btns">
                    <span @click="delPhotoItem(item.id)">删除</span>
                    <span @click="downloadphoto(item.fileName)">下载</span>
                    <span @click="setCover(item.id)">设为封面</span>
                  </div>
                </div>
              </div>
              <div class="photo-empty" v-show="!photo.length">暂无图片</div>
            </div>
          </div>
        </div>
        <div class="detail-item estate-photos estate-vr" ref="estateVr">
          <div class="detail-title">VR信息</div>
          <div class="detail-item-main">
            <el-tabs
              v-model="activeVr"
              @tab-click="switchVr"
              class="estate-detail-tab vr-tab"
            >
              <el-tab-pane
                v-for="item in vrs"
                :key="item.id"
                :label="item.type"
                :name="item.type"
              ></el-tab-pane>
            </el-tabs>
            <div class="photos-operation">
              <el-checkbox
                v-model="vrAllChecked"
                class="all-check"
                @change="checkAllVrs"
                >全选</el-checkbox
              >

              <el-button
                :disabled="!isVrOperationDisabled()"
                @click="delBatchVrs"
                >删除</el-button
              >
              <el-button type="primary" @click="isEditInfo.isCreateVr = true"
                >添加VR链接</el-button
              >
            </div>
            <div class="photos-main">
              <div
                class="photo-item"
                v-for="(item, index) in vr"
                :key="index"
                v-show="vr.length && item.url"
              >
                <img
                  src="@/assets/image/vr-cover.png"
                  class="estate-photo estate-vr"
                />
                <div class="cover" v-if="item.isCover">封面</div>
                <el-checkbox
                  v-model="item.checked"
                  class="item-checked"
                  @change="checkVrItem(item.checked)"
                ></el-checkbox>
                <div class="photo-detail">
                  <span>{{ item.type }}</span>
                  <div class="name-utc">
                    {{ item.creationTime | dateFormat }}
                  </div>
                  <div class="detail-btns">
                    <span @click="delVrItem(item.id)">删除</span>
                    <span
                      v-clipboard:copy="item.url"
                      v-clipboard:success="copyVrUrl"
                      >复制链接</span
                    >
                    <span @click="setVrCover(item.id)">设为封面</span>
                  </div>
                </div>
              </div>
              <div class="photo-empty" v-if="isVrEmpty">暂无VR</div>
            </div>
          </div>
        </div>
        <div
          class="detail-item estate-file estate-photos"
          ref="estateFile"
          v-if="permissions['Estate.LookMaterials']"
        >
          <div class="detail-title">附件信息</div>
          <div class="detail-item-main">
            <el-tabs
              v-model="activeFiles"
              @tab-click="switchFiles"
              class="estate-detail-tab file-tab"
            >
              <el-tab-pane
                v-for="(item, index) in files"
                :key="index"
                :label="item.type + '（' + item.number + '）'"
                :name="item.type"
              ></el-tab-pane>
            </el-tabs>
            <div class="photos-operation">
              <el-checkbox
                v-model="filesAllChecked"
                class="all-check"
                @change="checkAllFiles"
                >全选</el-checkbox
              >

              <el-select
                v-model="photoSelectText"
                class="photos-select"
                @change="filesSelect"
                :disabled="!isFilesOperationDisabled()"
              >
                <el-option
                  v-for="item in filesType"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                :disabled="!isFilesOperationDisabled()"
                @click="delBatchFiles"
                >删除</el-button
              >
              <el-button type="primary" @click="uploadFiles"
                >上传附件</el-button
              >
              <!-- <el-button
              :disabled="!isFilesOperationDisabled()"
              @click="downloadfiles"
              >下载</el-button
            > -->
            </div>
            <div class="photos-main">
              <div
                class="photo-item"
                v-for="(item, index) in file"
                :key="index"
              >
                <el-image
                  v-if="item.fileType == 'image'"
                  :src="item.url"
                  class="photo-img"
                  lazy
                ></el-image>
                <img
                  src="@/assets/image/video-cover.png"
                  v-else-if="item.fileType == 'video'"
                  class="estate-photo estate-video"
                />
                <img
                  src="@/assets/image/file-cover.png"
                  v-else
                  class="estate-photo estate-doc"
                />
                <el-checkbox
                  v-model="item.checked"
                  class="item-checked"
                  @change="checkItem(item.checked, 'file')"
                ></el-checkbox>
                <div class="photo-detail">
                  <div class="file-type-item">
                    <span>{{ item.type }}</span
                    ><span
                      class="file-length"
                      v-if="item.fileType == 'video'"
                      >{{ item.length | changeSize }}</span
                    >
                  </div>
                  <!-- <div class="name-utc">{{ item.creationTime | dateFormat }}</div> -->
                  <span class="name-utc item-name">{{ item.fileName }}</span>
                  <div class="detail-btns">
                    <span @click="delFileItem(item.id)">删除</span>
                    <span
                      @click="videoUrl = item.url"
                      v-if="item.fileType == 'video'"
                      >播放</span
                    >
                    <span @click="download(item.fileName)">下载</span>
                  </div>
                </div>
              </div>
              <video-play
                v-if="videoUrl"
                :url="videoUrl"
                @closeVideo="closeVideo"
              ></video-play>
              <div class="photo-empty" v-show="!file.length">暂无附件</div>
            </div>
          </div>
        </div>
        <div class="detail-item project-counselors" ref="preSellCards">
          <div class="detail-title">
            预售证信息
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="editModule('preSellCard')"
              >添加</el-button
            >
          </div>
          <div class="detail-item-main">
            <el-table :data="preSellCards" border>
              <el-table-column prop="cardNumber" label="预售证号">
              </el-table-column>
              <el-table-column label="预售证有效期">
                <template slot-scope="scope">
                  {{ scope.row.expirationStartTime | dateFormatYMD }}~{{
                    scope.row.expirationEndTime | dateFormatYMD
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="ratifyNumber" label="批准上市套数">
              </el-table-column>
              <el-table-column prop="ratifyArea" label="批准上市面积">
              </el-table-column>
              <el-table-column prop="bindFloor" label="绑定楼栋">
              </el-table-column>
              <el-table-column label="操作" width="95" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation">
                    <el-button
                      @click.native.prevent="
                        editPreSellCards(scope.row, scope.index)
                      "
                      type="text"
                      >编辑</el-button
                    >
                    <el-button
                      @click.native.prevent="
                        delPreSellCards(scope.row.preSellCardId)
                      "
                      type="text"
                      class="del-btn"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <el-dialog
        title="上传照片"
        :visible.sync="isUploadPhotos"
        @close="uploadPhotosClose"
        class="dialog-upload dialog-auto"
      >
        <div class="upload-main">
          <el-upload
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="uploadPhotosChange"
            :file-list="uploadPhotoList"
            :show-file-list="false"
            :auto-upload="false"
            multiple
            accept=".jpg, .png, .jpeg"
          >
            <div class="upload-btn">
              <div>
                <i slot="default" class="el-icon-plus"></i>
                <br />上传
              </div>
            </div>
          </el-upload>
          <div
            class="photo-item"
            v-for="(item, index) in uploadPhotoList"
            :key="index"
          >
            <div class="img-box">
              <el-checkbox
                v-model="item.checked"
                @change="checkPhotoItem(item.checked)"
                class="item-checkbox"
              ></el-checkbox>
              <img :src="item.url" class="photo-img" />
              <div class="del-btn">
                <span @click="delPhotoItme(index)">删除</span>
              </div>
            </div>
            <el-select
              class="item-select"
              :class="{ 'error-item': item.error }"
              @change="photoSelect(item)"
              v-model="item.type"
              placeholder="请选择分类"
              clearable
            >
              <el-option
                v-for="item in photosType"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-checkbox
              v-model="checkAllPhoto"
              @change="checkAllPhotoChange"
              :disabled="uploadPhotoList.length == 0"
              >全选</el-checkbox
            >
            <span class="batch-set">批量设置分类：</span>
            <el-select
              v-model="batchSetText"
              placeholder="请选择分类"
              @change="batchSetSelect"
              :disabled="!isTypeDisabled"
            >
              <el-option
                v-for="item in photosType"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div>
            <el-button @click="isUploadPhotos = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitUploadPhotos"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="上传附件"
        :visible.sync="isUploadFiles"
        @close="uploadFilesClose"
        class="dialog-upload dialog-auto"
      >
        <div class="upload-main">
          <el-upload
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="uploadFilesChange"
            :file-list="uploadFileList"
            :show-file-list="false"
            :auto-upload="false"
            multiple
            accept=".jpg, .png, .jpeg,.doc,.docx,.pdf,.xlsx,.mp4,.m3u8"
          >
            <div class="upload-btn">
              <div>
                <i slot="default" class="el-icon-plus"></i>
                <br />上传
              </div>
            </div>
          </el-upload>
          <div
            class="photo-item"
            v-for="(item, index) in uploadFileList"
            :key="index"
          >
            <div class="img-box">
              <el-checkbox
                v-model="item.checked"
                @change="checkFileItem(item.checked)"
                class="item-checkbox"
              ></el-checkbox>
              <div class="photo-img">
                <img
                  :src="item.url"
                  class="estate-img"
                  v-if="item.fileType == 'image'"
                />
                <img
                  src="@/assets/image/video-cover.png"
                  v-else-if="item.fileType == 'video'"
                  class="estate-video estate-photo"
                />
                <img
                  src="@/assets/image/file-cover.png"
                  v-else
                  class="estate-doc estate-photo"
                />
                <div v-if="item.fileType != 'image'">{{ item.fileName }}</div>
              </div>
              <div class="del-btn">
                <span @click="delFileItme(index)">删除</span>
              </div>
            </div>
            <el-select
              class="item-select"
              :class="{ 'error-item': item.error }"
              v-model="item.type"
              placeholder="请选择分类"
              clearable
            >
              <el-option
                v-for="item in filesType"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-checkbox
              v-model="checkAllFile"
              @change="checkAllFileChange"
              :disabled="uploadFileList.length == 0"
              >全选</el-checkbox
            >
            <span class="batch-set">批量设置分类：</span>
            <el-select
              v-model="batchSetText"
              placeholder="请选择分类"
              @change="fileBatchSetSelect"
              :disabled="!isFileTypeDisabled"
            >
              <el-option
                v-for="item in filesType"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div>
            <el-button @click="isUploadFiles = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitUploadFiles"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="基础信息"
        :visible.sync="isEditInfo.basic"
        @close="handleClose('basicForm')"
        class="dialog-auto dialog-basic"
      >
        <el-form
          label-position="left"
          label-width="5rem"
          ref="basicForm"
          :rules="basicRules"
          :model="basicForm"
        >
          <div class="estate-item">
            <el-form-item label="项目地址" required class="address-form min-input">
              <div class="flex-form">
                <el-form-item prop="city">
                  <el-select
                    v-model="basicForm.city"
                    clearable
                    placeholder="城市"
                    filterable
                    remote
                    :remote-method="remoteMethod"
                    @change="cityChange"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="district">
                  <el-select
                    :no-data-text="basicForm.city ? '暂无数据' : '请先选择城市'"
                    v-model="basicForm.district"
                    clearable
                    filterable
                    placeholder="县/区"
                    @change="districtChange"
                  >
                    <el-option
                      v-for="item in districtOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name + '&$' + item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="street">
                  <el-select
                    v-model="basicForm.street"
                    :no-data-text="
                      basicForm.district ? '暂无数据' : '请先选择县/区'
                    "
                    clearable
                    filterable
                    placeholder="街道"
                    @change="streetChange"
                  >
                    <el-option
                      v-for="item in streetOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name + '&$' + item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="business">
                  <el-select
                    v-model="basicForm.business"
                    :no-data-text="
                      basicForm.street ? '暂无数据' : '请先选择街道'
                    "
                    clearable
                    filterable
                    placeholder="商圈"
                  >
                    <el-option
                      v-for="item in businessOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="realAddress" class="address-input">
                  <el-input
                    v-model="basicForm.realAddress"
                    placeholder="详细地址（40字以内）"
                    maxlength="40"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
            <div class="flex-items">
              <div class="flex-item">
                <el-form-item label="楼盘名称" prop="name">
                  <el-input
                    v-model="basicForm.name"
                    placeholder="请输入楼盘名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="注册名称" class="margin-bottom">
                  <el-input
                    v-model="basicForm.registerName"
                    placeholder="请输入注册名称"
                    clearable
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="flex-item">
                <el-form-item label="推广名称" prop="promotionName">
                  <el-input
                    v-model="basicForm.promotionName"
                    placeholder="请输入推广名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="概要地址">
                  <el-input
                    v-model="basicForm.synopsisAddress"
                    placeholder="请输入概要地址"
                    maxlength="40"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item
              label="楼盘定位"
              prop="locationAddress"
              class="auto-height"
            >
              <div class="location-tip" v-if="addressQuery.latitude">
                该楼盘已设置楼盘地址，你可以点击
                <span class="theme-color" @click="isShowAddress = true"
                  >重新定位</span
                >
                修改楼盘地址，也可以
                <span
                  class="theme-color del"
                  @click="
                    addressQuery = { address: '', latitude: '', longitude: '' };
                    basicForm.locationAddress = '';
                  "
                  >清除定位</span
                >。
              </div>
              <div class="location-tip" v-else>
                该楼盘暂未获取楼盘地址，你可以点击
                <span class="theme-color" @click="getAddress">获取定位</span>
                添加楼盘地址
              </div>
              <baidu-map
                v-if="addressQuery.latitude"
                :center="center"
                :zoom="zoom"
                @ready="showAddressHandler"
                id="showAddress"
                :scroll-wheel-zoom="true"
              ></baidu-map>
            </el-form-item>
            <div class="flex-items">
              <div class="flex-item">
                <el-form-item label="总价区间" required class="min-input">
                  <div class="flex-form">
                    <el-form-item prop="minTotalPrice">
                      <el-input
                        v-model="basicForm.minTotalPrice"
                        placeholder="请输入总价最小值"
                        type="number"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span class="item-unit">-</span>
                    <el-form-item prop="maxTotalPrice">
                      <el-input
                        v-model="basicForm.maxTotalPrice"
                        placeholder="请输入总价最大值"
                        type="number"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span class="item-unit">万元</span>
                  </div>
                </el-form-item>
                <el-form-item label="均价区间" required class="min-input">
                  <div class="flex-form">
                    <el-form-item prop="minPrice">
                      <el-input
                        v-model="basicForm.minPrice"
                        placeholder="请输入均价最小值"
                        type="number"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span class="item-unit">-</span>
                    <el-form-item prop="maxPrice">
                      <el-input
                        v-model="basicForm.maxPrice"
                        placeholder="请输入均价最大值"
                        type="number"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span class="item-unit">元/m²</span>
                  </div>
                </el-form-item>
                <el-form-item class="transfer-form-item" label="用途">
                  <div class="transfer-select" @click="openFiltrate">
                    <span
                      class="placeholder"
                      v-if="basicForm.usingTypes.length < 1"
                      >请选择用途</span
                    >
                    <div
                      class="select-item"
                      v-for="(item, index) in basicForm.usingTypes"
                      v-show="index < 3"
                      :key="index"
                    >
                      <span>{{ item }}</span>
                      <div
                        class="del-fixed-item"
                        @click.stop="delUseItem(basicForm.usingTypes, index)"
                      >
                        <svg-icon icon-class="close-ico"></svg-icon>
                      </div>
                    </div>
                    <div v-if="basicForm.usingTypes.length > 3">...</div>
                    <div class="suffix">
                      <i
                        class="el-icon-circle-close"
                        @click.stop="basicForm.usingTypes = []"
                        v-if="basicForm.usingTypes.length"
                      ></i>
                      <i
                        class="el-icon-caret-bottom"
                        :class="{
                          'inline-block': !basicForm.usingTypes.length,
                        }"
                      ></i>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="开发商">
                  <el-input
                    v-model="basicForm.developerName"
                    placeholder="请输入开发商"
                    clearable
                    maxlength="40"
                  ></el-input>
                </el-form-item>
                <el-form-item label="售楼处电话" prop="salePhoneNumber">
                  <el-input
                    v-model="basicForm.salePhoneNumber"
                    placeholder="请输入售楼处电话"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="开盘时间">
                  <el-date-picker
                    align="center"
                    v-model="basicForm.launchTime"
                    type="date"
                    placeholder="请选择开盘时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="代理时间" class="time-item">
                  <el-date-picker
                    align="center"
                    v-model="basicForm.agentRange"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="物业公司">
                  <el-input
                    v-model="basicForm.serviceCompany"
                    placeholder="请输入物业公司"
                    maxlength="20"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="物业管理费">
                  <el-input
                    placeholder="请输入物业管理费"
                    v-model="basicForm.serviceFee"
                    type="number"
                  >
                  </el-input>
                  <span class="item-unit">元/㎡/月</span>
                </el-form-item>
              </div>
              <div class="flex-item">
                <el-form-item label="销售进度" prop="saleStatus">
                  <el-radio-group v-model="basicForm.saleStatus">
                    <el-radio
                      v-for="(item, key) in saleStatusOptions"
                      :label="key"
                      :key="key"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="建筑类型">
                  <el-radio-group v-model="basicForm.buildType">
                    <el-radio
                      v-for="item in buildTypeOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="售楼地址">
                  <el-input
                    v-model="basicForm.saleAddress"
                    placeholder="请输入售楼地址"
                    clearable
                    maxlength="40"
                  ></el-input>
                </el-form-item>
                <el-form-item label="可住情况" prop="reside">
                  <el-radio-group v-model="basicForm.reside">
                    <el-radio
                      v-for="item in resideOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="交房时间">
                  <el-date-picker
                    align="center"
                    v-model="basicForm.deliveryTime"
                    type="date"
                    placeholder="请选择交房时间"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="竣工时间">
                  <el-date-picker
                    align="center"
                    v-model="basicForm.buildTime"
                    type="date"
                    placeholder="请选择竣工时间"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="物业电话" prop="servicePhoneNumber">
                  <el-input
                    v-model="basicForm.servicePhoneNumber"
                    placeholder="请输入物业电话"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="物业地址">
                  <el-input
                    v-model="basicForm.serviceAddress"
                    placeholder="请输入物业地址"
                    maxlength="20"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.basic = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitEstateBasic"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="选择用途"
        :visible.sync="isFiltrateShow"
        :before-close="usesClose"
        custom-class="filter-dialog"
      >
        <el-transfer
          filterable
          :titles="['可选择用途', '已选择用途']"
          filter-placeholder="请输入用途名称"
          v-model="basicForm.usingTypes"
          :data="useTypes"
          :filter-method="filterMethod"
        ></el-transfer>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isFiltrateShow = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="选择用途"
        :visible.sync="isFiltrateTypeShow"
        :before-close="usesClose"
        custom-class="filter-dialog"
      >
        <el-transfer
          filterable
          :titles="['可选择用途', '已选择用途']"
          filter-placeholder="请输入用途名称"
          v-model="estateTypeForm.usingTypes"
          :data="useTypes"
          :filter-method="filterMethod"
        ></el-transfer>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isFiltrateTypeShow = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 获取定位 -->
      <el-dialog
        title="获取定位"
        :visible.sync="isShowAddress"
        :before-close="addressClose"
        width="800px"
        custom-class="add-filling address"
      >
        <el-form
          :model="addressQuery"
          label-width="5rem"
          label-position="left"
          @submit.native.prevent
        >
          <el-form-item label="楼盘地址" class="auto-height">
            <el-input
              clearable
              @keyup.enter.native="changeAddress()"
              v-model="addressQuery.address"
              placeholder="请输入楼盘地址,回车结束"
            ></el-input>
            <div class="map-group">
              <baidu-map
                v-if="addressQuery.address"
                :center="center"
                :zoom="zoom"
                id="allmap"
                :scroll-wheel-zoom="true"
              ></baidu-map>
              <div class="address-list">
                <div class="select-tip" v-if="addressList.length">
                  请选择楼盘地址<span class="rule-tip">*</span>
                </div>
                <div
                  class="item"
                  v-for="(item, index) in addressList"
                  :key="index"
                >
                  <div
                    class="marker"
                    :style="'background-position: -23px -' + 25 * index + 'px;'"
                  ></div>
                  <div class="info" @click="chooseAddress(item)">
                    <div>
                      <a :href="item.url" target="_blank">{{ item.title }}</a>
                    </div>
                    <div>地址：{{ item.address }}</div>
                    <div>坐标：{{ item.point.lng }},{{ item.point.lat }}</div>
                  </div>
                </div>
                <div class="no-data" v-if="addressList.length == 0">
                  暂无相关地点，请<span v-if="isEnterAddress">重新</span
                  >输入楼盘地址
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="error-tip" v-if="isAddressError">请选择楼盘地址</div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isShowAddress = false">取消</el-button>
          <el-button type="primary" @click="addressSubmit">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="项目人员"
        :before-close="counselorsClose"
        :visible.sync="isEditInfo.counselors"
        class="dialog-counselors"
      >
        <div class="counselors-main">
          <el-form label-position="left" label-width="11rem">
            <el-form-item
              label="项目负责人（内部员工）"
              class="auto-height counselors-form-items"
              required
            >
              <div
                v-for="(item, index) in counselorsForm.managers"
                :key="index"
                class="counselors-form"
              >
                <el-form-item>
                  <el-autocomplete
                    popper-class="counselors-autocomplete"
                    v-model="item.userName"
                    :fetch-suggestions="querySearch"
                    placeholder="请选择项目负责人"
                    clearable
                    @blur="counselorSelectBlur(item)"
                    @select="counselorSelect"
                  >
                    <i class="el-icon-search el-input__icon" slot="suffix"> </i>
                    <template slot-scope="{ item }">
                      <div
                        @click="selectCounselorIndex(index)"
                        class="template-item"
                      >
                        <div class="name">{{ item.name }}</div>
                        <div class="org">{{ item.organizationUnit }}</div>
                      </div>
                    </template>
                  </el-autocomplete>
                  <div class="error-tip" v-if="item.error.userName">
                    请选择项目负责人
                  </div>
                </el-form-item>
                <span class="phone-lable">手机<span>*</span></span>
                <el-form-item>
                  <el-input
                    disabled
                    v-model="item.userPhoneNumber"
                    @blur="counselorsPhoneBlur(item)"
                    clearable
                    placeholder="请输入手机号"
                    class="margin-right"
                  ></el-input>
                  <div class="error-tip" v-if="item.error.userPhoneNumber">
                    请输入正确的手机号
                  </div>
                </el-form-item>
                <span
                  v-if="
                    index == counselorsForm.managers.length - 1 && index < 4
                  "
                  @click="addCounselors('managers')"
                  class="add-counselors theme-color"
                  >添加</span
                >
                <span
                  v-if="index > 0"
                  @click="delCounselors('managers', index)"
                  class="del-poeson"
                  >删除</span
                >
                <span
                  v-if="index == 0"
                  class="del-poeson"
                  ></span
                >
              </div>
            </el-form-item>
            <el-form-item
              label="项目助理（内部员工）"
              class="auto-height counselors-form-items"
              required
            >
              <div
                v-for="(item, index) in counselorsForm.assistants"
                :key="index"
                class="counselors-form"
              >
                <el-form-item>
                  <el-autocomplete
                    popper-class="counselors-autocomplete"
                    v-model="item.userName"
                    :fetch-suggestions="querySearch"
                    clearable
                    placeholder="请选择项目助理"
                    @blur="counselorSelectBlur(item)"
                    @select="assistantSelect"
                  >
                    <i class="el-icon-search el-input__icon" slot="suffix"> </i>
                    <template slot-scope="{ item }">
                      <div
                        @click="selectCounselorIndex(index)"
                        class="template-item"
                      >
                        <div class="name">{{ item.name }}</div>
                        <div class="org">{{ item.organizationUnit }}</div>
                      </div>
                    </template>
                  </el-autocomplete>
                  <div class="error-tip" v-if="item.error.userName">
                    请选择项目助理
                  </div>
                </el-form-item>
                <span class="phone-lable">手机<span>*</span></span>
                <el-form-item>
                  <el-input
                    disabled
                    v-model="item.userPhoneNumber"
                    clearable
                    placeholder="请输入手机号"
                    class="margin-right"
                    @blur="counselorsPhoneBlur(item)"
                  ></el-input>
                  <div class="error-tip" v-if="item.error.userPhoneNumber">
                    请输入正确的手机号
                  </div>
                </el-form-item>
                <span
                  v-if="
                    index == counselorsForm.assistants.length - 1 && index < 4
                  "
                  @click="addCounselors('assistants')"
                  class="add-counselors theme-color"
                  >添加</span
                >
                <span
                  v-if="index > 0"
                  @click="delCounselors('assistants', index)"
                  class="del-poeson"
                  >删除</span
                >
              </div>
            </el-form-item>
            <el-form-item label="案场接待" class="auto-height">
              <div
                v-if="counselorsForm.receivers.length"
                class="counselors-items"
              >
                <div
                  v-for="(item, index) in counselorsForm.receivers"
                  :key="index"
                  class="counselors-item"
                >
                  <el-form-item>
                    <el-radio-group v-model="item.userType" @change='receiverUserTypeChange(index)'>
                      <el-radio label="内部"></el-radio>
                      <el-radio label="外部"></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div class="counselors-form">
                    <el-form-item>
                      <el-autocomplete
                        v-if="item.userType=='内部'"
                        popper-class="counselors-autocomplete"
                        v-model="item.userName"
                        :fetch-suggestions="querySearch"
                        clearable
                        placeholder="请选择案场接待"
                        @blur="counselorSelectBlur(item)"
                        @select="receiversSelect"
                      >
                        <i class="el-icon-search el-input__icon" slot="suffix">
                        </i>
                        <template slot-scope="{ item }">
                          <div
                            @click="selectCounselorIndex(index)"
                            class="template-item"
                          >
                            <div class="name">{{ item.name }}</div>
                            <div class="org">{{ item.organizationUnit }}</div>
                          </div>
                        </template>
                      </el-autocomplete>
                      <el-input
                        v-else
                        v-model="item.userName"
                        placeholder="请输入案场接待"
                        clearable
                        @input="counselorsCopy"
                        @blur="counselorsNameBlur(item)"
                      ></el-input>
                      <div class="error-tip" v-if="item.error.userName">
                        请{{item.userType=='内部'?'选择':'输入'}}案场接待
                      </div>
                    </el-form-item>
                    <span class="phone-lable">手机<span>*</span></span>
                    <el-form-item>
                      <el-input
                        :disabled="item.userType=='内部'"
                        v-model="item.userPhoneNumber"
                        placeholder="请输入手机号"
                        clearable
                        class="margin-right"
                        @input="counselorsCopy"
                        @blur="counselorsPhoneBlur(item)"
                      ></el-input>
                      <div class="error-tip" v-if="item.error.userPhoneNumber">
                        请输入正确的手机号
                      </div>
                    </el-form-item>
                    <span
                      v-if="
                        index == counselorsForm.receivers.length - 1 &&
                        index < 4
                      "
                      @click="addCounselors('receivers')"
                      class="add-counselors theme-color"
                      >添加</span
                    >
                    <span
                      @click="delCounselors('receivers', index)"
                      class="del-poeson"
                      >删除</span
                    >
                  </div>
                </div>
              </div>
              <span
                v-else
                class="theme-color"
                @click="addCounselors('receivers')"
              >
                添加
              </span>
            </el-form-item>
            <el-form-item label="开发商/代理商对接人" class="auto-height">
              <div
                v-if="counselorsForm.developers.length"
                class="counselors-items"
              >
                <div
                  v-for="(item, index) in counselorsForm.developers"
                  :key="index"
                  class="counselors-item"
                >
                  <el-form-item>
                    <el-radio-group v-model="item.userType" @change='developerUserTypeChange(index)'>
                      <el-radio label="内部"></el-radio>
                      <el-radio label="外部"></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div class="counselors-form">
                    <el-form-item>
                      <el-autocomplete
                        v-if="item.userType=='内部'"
                        popper-class="counselors-autocomplete"
                        v-model="item.userName"
                        :fetch-suggestions="querySearch"
                        clearable
                        placeholder="请选择对接人"
                        @blur="counselorSelectBlur(item)"
                        @select="developersSelect"
                      >
                        <i class="el-icon-search el-input__icon" slot="suffix">
                        </i>
                        <template slot-scope="{ item }">
                          <div
                            @click="selectCounselorIndex(index)"
                            class="template-item"
                          >
                            <div class="name">{{ item.name }}</div>
                            <div class="org">{{ item.organizationUnit }}</div>
                          </div>
                        </template>
                      </el-autocomplete>
                      <el-input
                        v-else
                        v-model="item.userName"
                        placeholder="请输入对接人"
                        clearable
                        @input="counselorsCopy"
                        @blur="counselorsNameBlur(item)"
                      ></el-input>
                      <div class="error-tip" v-if="item.error.userName">
                        请{{item.userType=='内部'?'选择':'输入'}}对接人
                      </div>
                    </el-form-item>
                    <span class="phone-lable">手机<span>*</span></span>
                    <el-form-item>
                      <el-input
                        :disabled="item.userType=='内部'"
                        v-model="item.userPhoneNumber"
                        clearable
                        class="margin-right"
                        placeholder="请输入手机号"
                        @input="counselorsCopy"
                        @blur="counselorsPhoneBlur(item)"
                      ></el-input>
                      <div class="error-tip" v-if="item.error.userPhoneNumber">
                        请输入正确的手机号
                      </div>
                    </el-form-item>
                    <span
                      v-if="
                        index == counselorsForm.developers.length - 1 &&
                        index < 4
                      "
                      @click="addCounselors('developers')"
                      class="add-counselors theme-color"
                      >添加</span
                    >
                    <span
                      @click="delCounselors('developers', index)"
                      class="del-poeson"
                      >删除</span
                    >
                  </div>
                </div>
              </div>
              <span
                v-else
                class="theme-color"
                @click="addCounselors('developers')"
              >
                添加
              </span>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="counselorsClose">取 消</el-button>
          <el-button
            type="primary"
            @click="submitCounselors"
            :loading="isLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="楼盘卖点"
        :visible.sync="isEditInfo.salePoint"
        @close="handleClose('salePointForm')"
        class="dialog-sale-point"
      >
        <el-form
          label-position="left"
          label-width="5rem"
          ref="salePointForm"
          :model="salePointForm"
        >
          <el-form-item label="项目特色">
            <div class="flex-form">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="isAllFeatures"
                @change="checkAllFeaturesChange"
                class="margin-right"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="salePointForm.features"
                @change="checkedFeaturesChange"
              >
                <el-checkbox
                  v-for="(item, index) in featuresOptions"
                  :key="index"
                  :label="item"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="项目描述" class="auto-height">
            <el-input
              type="textarea"
              v-model="salePointForm.description"
              maxlength="500"
              placeholder="请输入项目描述"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item label="周边配套" class="auto-height">
            <el-input
              type="textarea"
              v-model="salePointForm.perimeter"
              maxlength="500"
              placeholder="请输入周边配套"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEditInfo.salePoint = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitSalePoint"
            :loading="isLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="小区信息"
        :visible.sync="isEditInfo.community"
        class="dialog-community"
      >
        <el-form
          label-position="left"
          label-width="6rem"
          ref="communityForm"
          :model="communityForm"
        >
          <div class="estate-item">
            <div class="flex-items">
              <div class="flex-item">
                <el-form-item label="建筑面积">
                  <el-input
                    v-model="communityForm.landSquare"
                    type="number"
                    placeholder="请输入建筑面积"
                    clearable
                  >
                    <template slot="append">㎡</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="容积率">
                  <el-input
                    v-model="communityForm.plotRate"
                    type="number"
                    placeholder="请输入容积率"
                    clearable
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="规划户数">
                  <el-input
                    v-model="communityForm.householdCount"
                    type="number"
                    v-enter-number
                    placeholder="请输入规划户数"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="地上车位数">
                  <el-input
                    v-model="communityForm.overgroundCarportCount"
                    type="number"
                    v-enter-number
                    placeholder="请输入地上车位数"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="地下车位数">
                  <el-input
                    v-model="communityForm.undergroundCarportCount"
                    type="number"
                    v-enter-number
                    placeholder="请输入地下车位数"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="有无电梯">
                  <el-radio-group v-model="communityForm.isElevator">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="供水类型" class="margin-bottom">
                  <el-radio-group v-model="communityForm.waterType">
                    <el-radio
                      v-for="item in communityTypeOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </div>
              <div class="flex-item">
                <el-form-item label="占地面积">
                  <el-input
                    v-model="communityForm.square"
                    type="number"
                    placeholder="请输入占地面积"
                    clearable
                  >
                    <template slot="append">㎡</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="绿化率">
                  <el-input
                    v-model="communityForm.greenRate"
                    type="number"
                    placeholder="请输入绿化率"
                    clearable
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="楼栋总数">
                  <el-input
                    v-model="communityForm.buildingCount"
                    type="number"
                    v-enter-number
                    placeholder="请输入楼栋总数"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="建筑层数">
                  <el-input
                    v-model="communityForm.floorTotalCount"
                    type="number"
                    v-enter-number
                    placeholder="请输入建筑层数"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="有无燃气">
                  <el-radio-group v-model="communityForm.isGas">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="供电类型">
                  <el-radio-group v-model="communityForm.electricityType">
                    <el-radio
                      v-for="item in communityTypeOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="供暖类型">
                  <el-radio-group v-model="communityForm.heatType">
                    <el-radio
                      v-for="item in heatTypeOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="装修情况">
              <el-radio-group v-model="communityForm.decoration">
                <el-radio
                  v-for="item in decorationOptions"
                  :label="item"
                  :key="item"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="产权年限">
              <el-checkbox-group v-model="communityForm.useRightYears">
                <el-checkbox
                  v-for="(item, index) in useRightYearsOptions"
                  :key="index"
                  :label="item"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="产权性质">
              <el-checkbox-group v-model="communityForm.useRightTypes">
                <el-checkbox
                  v-for="(item, index) in useRightTypeOptions"
                  :key="index"
                  :label="item"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.community = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitCommunity"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :title="estateTypeTitle"
        :visible.sync="isEditInfo.estateType"
        @close="handleClose('estateTypeForm')"
        class="dialog-auto dialog-house-type"
      >
        <el-form
          label-position="left"
          label-width="7rem"
          ref="estateTypeForm"
          :rules="estateTypeRules"
          :model="estateTypeForm"
        >
          <el-form-item label="户型名称" prop="name">
            <el-input
              class="width-input"
              v-model="estateTypeForm.name"
              placeholder="请输入户型名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="房型" required>
            <div class="flex-form type-form">
              <el-form-item prop="bedroomNumber">
                <el-input
                  v-model="estateTypeForm.bedroomNumber"
                  type="number"
                  clearable
                ></el-input>
                <span class="item-unit">室</span>
              </el-form-item>
              <el-form-item prop="livingRoomNumber">
                <el-input
                  v-model="estateTypeForm.livingRoomNumber"
                  type="number"
                  clearable
                ></el-input>
                <span class="item-unit">厅</span>
              </el-form-item>
              <el-form-item prop="kitchenNumber">
                <el-input
                  v-model="estateTypeForm.kitchenNumber"
                  type="number"
                  clearable
                ></el-input>
                <span class="item-unit">厨房</span>
              </el-form-item>
              <el-form-item prop="bathroomNumber">
                <el-input
                  v-model="estateTypeForm.bathroomNumber"
                  type="number"
                  clearable
                ></el-input>
                <span class="item-unit">卫生间</span>
              </el-form-item>
              <el-form-item prop="balconyNumber">
                <el-input
                  v-model="estateTypeForm.balconyNumber"
                  type="number"
                  clearable
                ></el-input>
                <span class="item-unit">阳台</span>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            class="transfer-form-item"
            label="用途"
            prop="usingTypes"
          >
            <div class="transfer-select width-input" @click="isFiltrateTypeShow = true">
              <span
                class="placeholder"
                v-if="estateTypeForm.usingTypes.length < 1"
                >请选择用途</span
              >
              <div
                class="select-item"
                v-for="(item, index) in estateTypeForm.usingTypes"
                v-show="index < 7"
                :key="index"
              >
                <span>{{ item }}</span>
                <div
                  class="del-fixed-item"
                  @click.stop="delUseItem(estateTypeForm.usingTypes, index)"
                >
                  <svg-icon icon-class="close-ico"></svg-icon>
                </div>
              </div>
              <div v-if="estateTypeForm.usingTypes.length > 7">...</div>
              <div class="suffix">
                <i
                  class="el-icon-circle-close"
                  @click.stop="estateTypeForm.usingTypes = []"
                  v-if="estateTypeForm.usingTypes.length"
                ></i>
                <i
                  class="el-icon-caret-bottom"
                  :class="{ 'inline-block': !estateTypeForm.usingTypes.length }"
                ></i>
              </div>
            </div>
          </el-form-item>
          <div class="flex-items">
            <div class="flex-item type-item">
              <el-form-item label="建筑面积" prop="buildArea">
                <el-input
                  v-model="estateTypeForm.buildArea"
                  placeholder="请输入建筑面积"
                  clearable
                  type="number"
                >
                  <template slot="append">㎡</template>
                </el-input>
              </el-form-item>
              <el-form-item label="装修" prop="decoration">
                <el-select
                  v-model="estateTypeForm.decoration"
                  clearable
                  placeholder="请选择装修"
                >
                  <el-option
                    v-for="item in decorationOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销售进度" prop="saleStatus">
                <el-select
                  v-model="estateTypeForm.saleStatus"
                  clearable
                  placeholder="请选择销售进度"
                >
                  <el-option
                    v-for="key in saleStatusOptions"
                    :key="key"
                    :label="saleStatusOptions[key]"
                    :value="key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex-item type-item">
              <el-form-item label="室内面积" prop="indoorArea">
                <el-input
                  v-model="estateTypeForm.indoorArea"
                  placeholder="请输入室内面积"
                  clearable
                  type="number"
                >
                  <template slot="append">㎡</template>
                </el-input>
              </el-form-item>
              <el-form-item label="总价" prop="totalPrice">
                <el-input
                  v-model="estateTypeForm.totalPrice"
                  placeholder="请输入总价"
                  clearable
                  type="number"
                >
                  <template slot="append">万</template>
                </el-input>
              </el-form-item>
              <el-form-item label="朝向" prop="orientationType">
                <el-select
                  v-model="estateTypeForm.orientationType"
                  clearable
                  placeholder="请选择朝向"
                >
                  <el-option
                    v-for="item in orientationTypeOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="备注" class="auto-height" prop="more">
            <el-input
              type="textarea"
              v-model="estateTypeForm.more"
              maxlength="200"
              placeholder="请输入备注"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传图片" class="auto-height" prop="coverUrl">
            <el-upload
              class="img-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-change="handleTypeImgChange"
              :http-request="getHousetypeFile"
            >
              <img v-if="typeImgUrl" :src="typeImgUrl" class="avatar" />
              <div class="upload-box" v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div>上传图片</div>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否设为主推" prop="isMainPush">
            <el-radio-group v-model="estateTypeForm.isMainPush">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="主推起止时间"
            prop="pushRange"
            v-if="estateTypeForm.isMainPush"
          >
            <el-date-picker
              align="center"
              v-model="estateTypeForm.pushRange"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="主推优先级"
            prop="sort"
            v-if="estateTypeForm.isMainPush"
          >
            <el-select
              v-model="estateTypeForm.sort"
              clearable
              placeholder="请选择主推优先级"
            >
              <el-option
                v-for="item in sortOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.estateType = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitEstateType"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :title="preSellCardTitle"
        :visible.sync="isEditInfo.preSellCard"
        @close="handleClose('preSellCardForm')"
        class="dialog-house-type"
      >
        <el-form
          label-position="left"
          label-width="7rem"
          ref="preSellCardForm"
          :rules="preSellCardRules"
          :model="preSellCardForm"
        >
          <div class="flex-items">
            <div class="flex-item type-item">
              <el-form-item label="预售证号" prop="cardNumber">
                <el-input
                  v-model="preSellCardForm.cardNumber"
                  placeholder="请输入预售证号"
                  clearable
                  class="card-number"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="预售有效期" prop="expirationRange">
                <el-date-picker
                  align="center"
                  v-model="preSellCardForm.expirationRange"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div class="flex-item type-item">
              <el-form-item label="批准上市套数" prop="ratifyNumber">
                <el-input
                  v-model="preSellCardForm.ratifyNumber"
                  placeholder="请输入上市套数"
                  type="number"
                  clearable
                >
                  <template slot="append">套</template>
                </el-input>
              </el-form-item>
              <el-form-item label="批准上市面积" prop="ratifyArea">
                <el-input
                  v-model="preSellCardForm.ratifyArea"
                  placeholder="请输入上市面积"
                  type="number"
                  clearable
                >
                  <template slot="append">㎡</template>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="绑定楼栋" class="auto-height" prop="bindFloor">
            <el-input
              type="textarea"
              v-model="preSellCardForm.bindFloor"
              maxlength="200"
              placeholder="请输入绑定楼栋"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.preSellCard = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitPreSellCard"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="添加VR链接"
        :visible.sync="isEditInfo.isCreateVr"
        @close="handleClose('vrForm')"
      >
        <el-form
          label-position="left"
          label-width="7rem"
          ref="vrForm"
          :rules="vrRules"
          :model="vrForm"
        >
          <el-form-item label="VR链接" prop="url">
            <el-input
              v-model="vrForm.url"
              placeholder="请输入VR链接"
              clearable
              class="vr-input"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="户型" prop="type">
            <el-select v-model="vrForm.type" clearable placeholder="请选择户型">
              <el-option
                v-for="item in vrTypeOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.isCreateVr = false">取 消</el-button>
            <el-button type="primary" @click="submitVr" :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <div v-if="isInit.isInit" class="loading-box">
      <img src="@/assets/image/loading.gif" />
    </div>
  </div>
</template>

<script>
import indexJs from "./index.js";
export default {
  ...indexJs,
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>